import * as React from 'react'
import { FC, useMemo } from 'react'
import {
  BulkActionCircularProgress,
  BulkActionErrorDescription,
  BulkActionErrorSummary,
} from '../../BulkActionErrors'
import { bulkActionErrors } from '../../constants'
import { ErrorSummary } from './typings'

type Props = {
  errorSummary: ErrorSummary
  loading: boolean
}

export const RowErrors: FC<Props> = (props) => {
  const {
    errorSummary: { count, hasAlreadyClosed },
    loading,
  } = props

  const description = useMemo(() => {
    const noun = count === 1 ? 'record' : 'records'
    return `${count} ${noun} found that cannot be updated.`
  }, [count])

  const display = useMemo(
    () => !loading && count > 0 && hasAlreadyClosed,
    [count, hasAlreadyClosed, loading],
  )

  return (
    <>
      <BulkActionCircularProgress loading={loading} mt={3} mx="auto" />
      {display && (
        <>
          <BulkActionErrorSummary description={description} />
          {hasAlreadyClosed && (
            <BulkActionErrorDescription
              detail={bulkActionErrors.updateExpectedClosingDate.closed}
            />
          )}
        </>
      )}
    </>
  )
}
RowErrors.displayName = 'RowErrors'
